<template>
  <div class="toggle" :class="{ on: value }" @click="$emit('input', !value)">
    <div class="rail">
      <div class="circle"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
  }
};
</script>

<style scoped>
.toggle {
  position: relative;
  width: 40px;
  height: 20px;
  padding: 2px 4px;
  cursor: pointer;
}
.rail {
  width: 100%;
  height: 16px;
  border-radius: 8px;
  background-color: rgba(0,0,0,.38);
}
.circle {
  position: absolute;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  left: 0;
  top: 0;
  box-shadow: 0 2px 1px -1px rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 1px 3px 0 rgb(0 0 0 / 12%);
  background-color: white;
  transition: left 300ms ease, background-color 300ms ease;
}
.toggle.on .circle {
  left: 20px;
  background-color: rgb(140, 48, 218);
}
.toggle.on .rail {
  background-color: rgba(140, 48, 218, 0.3);
}
</style>